module.exports = __webpack_public_path__ + "img/eir.082a57e.svg";